import React from "react";
import { c, t } from "ttag";

import { Meters } from "../../../models/nominals";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import {
    DISTANCE_OPTIONS,
    DistanceUnit,
    displayUnitToMeters,
    getDistanceUnit,
    metersToDisplayUnit,
} from "../../../utils/distance";
import { updateStoreFilters } from "../reducers";
import { storeFilterSelector } from "../selectors";

export const FilterDistanceSelect = (props: {
    selectProps?: React.DetailedHTMLProps<
        React.SelectHTMLAttributes<HTMLSelectElement>,
        HTMLSelectElement
    >;
}): React.ReactNode => {
    const currentValueMeters: Meters = useAppSelector(
        (state) => storeFilterSelector(state).distance,
    );
    const dispatch = useAppDispatch();

    const unit = getDistanceUnit();
    const steps = DISTANCE_OPTIONS[unit];
    // Convert from meters to display unit for showing current value
    const currentValueDisplay = Math.round(
        metersToDisplayUnit(currentValueMeters),
    );

    return (
        <>
            <select
                {...props.selectProps}
                value={currentValueDisplay}
                onChange={(e) => {
                    e.preventDefault();
                    const displayValue = parseInt(e.currentTarget.value, 10);
                    // Convert from display unit to meters for storage
                    dispatch(
                        updateStoreFilters({
                            distance: displayUnitToMeters(displayValue),
                        }),
                    );
                }}
                aria-describedby="retail-locator-distance_describedby"
            >
                {steps.map((step) => (
                    <option key={step} value={step}>
                        {unit === DistanceUnit.KILOMETERS
                            ? c("distance filter").t`${step} km`
                            : c("distance filter").t`${step} Miles`}
                    </option>
                ))}
            </select>
            <span
                className="ada-screenreader-only"
                id="retail-locator-distance_describedby"
            >
                {t`Select distance to filter from location`}
            </span>
        </>
    );
};
